import React from "react";
import { useObserver } from "mobx-react-lite";
import Avatar from "@material-ui/core/Avatar";
import { Link } from "react-router-dom";
import Dropzone from "react-fine-uploader/dropzone";

//TODO!!!
//import API from "services/api";
import AvatarUpload from "components/table/AvatarUpload";

const ProfileHeader = (props) => {
    const { store } = props;

    const handleFetchRecord = () => {
        store.record.reload();
    };

    return useObserver(() => {
        const { record } = store;
        return (
            <div className="jr-profile-banner">
                <div className="jr-profile-container">
                    <div className="jr-profile-banner-top">
                        <div className="jr-profile-banner-top-left">
                            <div className="jr-profile-banner-avatar">
                                <AvatarUpload store={store} />
                            </div>
                            <div className="jr-profile-banner-avatar-info">
                                <h2 className="mb-2 jr-mb-sm-3 jr-fs-xxl jr-font-weight-light">
                                    {record.name_short ? record.name_short : record.name}
                                </h2>
                                <p className="mb-0 jr-fs-lg">{record.description}</p>
                            </div>
                        </div>
                        <div className="jr-profile-banner-top-right">
                            <ul className="jr-follower-list">
                                <li>
                                    <span className="jr-follower-title jr-fs-lg jr-font-weight-medium">
                                        {record.balance || 0} руб
                                    </span>
                                    <span className="jr-fs-sm">Баланс</span>
                                </li>
                                <li>
                                    <span className="jr-follower-title jr-fs-lg jr-font-weight-medium">
                                        {record.client_count || 0}{" "}
                                    </span>
                                    <span className="jr-fs-sm">Клиентов</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="jr-profile-banner-bottom">
                        <div className="jr-tab-list">
                            <ul className="jr-navbar-nav">
                                <li>
                                    <span className="jr-link">
                                        <Link to={`/app/users/${record.id}`}>Сводка</Link>
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        );
    });
};

export default ProfileHeader;
